import 'apps/hiring/styles/components/hiring-sidenav.scss';
import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import { NavLink, Route } from 'library/util/core-router';
import PropTypes from 'prop-types';
import GearSvg from 'library/icons/gear.svg';

class HiringSidenav extends React.Component {
  render() {
    const { type, id } = this.props;
    return (
      <div className="hiring-sidenav">
        <div className="hiring-sidenav-body">
          { this.props.children }
          <NavLink to={`/hiring/${type}/${id == '' ? null : `${id}/`}settings`}><GearSvg />
            <span style={{ fontSize: '.75em' }}>Settings</span>
          </NavLink>
        </div>
      </div>
    );
  }
}

HiringSidenav.propTypes = {
  children: PropTypes.array,
  id: PropTypes.string,
  type: PropTypes.string,
};

const HiringSidenavWithRouter = ({ children, type='openings', ...props}) => (
  <Route path={`/hiring/${type}/:id`} render={({ match }) => (
    <HiringSidenav id={resolve(match, 'params/id', '')} type={type} {...props}>
      { children }
    </HiringSidenav>
  )} />
);

HiringSidenavWithRouter.propTypes = {
  children: PropTypes.array,
  type: PropTypes.string
};

export default HiringSidenavWithRouter;
